import { z } from 'zod';
/** Request/response schemas of the admin API (contracts/http-api.md). Shared by api and web. */
export const rolAdminSchema = z.enum(['operador', 'consulta']);
export const ingresoBodySchema = z.object({
    correo: z.string().trim().toLowerCase().email(),
    clave: z.string().min(1).max(200),
});
export const cambioClaveBodySchema = z.object({
    actual: z.string().min(1).max(200),
    nueva: z.string().min(12).max(200),
});
export const usuarioAdminDtoSchema = z.object({
    id: z.string().uuid(),
    correo: z.string(),
    nombre: z.string(),
    rol: rolAdminSchema,
    activo: z.boolean(),
    debeCambiarClave: z.boolean(),
});
export const sesionActualSchema = z.object({ usuario: usuarioAdminDtoSchema });
export const crearUsuarioBodySchema = z.object({
    correo: z.string().trim().toLowerCase().email(),
    nombre: z.string().trim().min(1).max(120),
    rol: rolAdminSchema,
});
export const usuarioCreadoSchema = z.object({ id: z.string().uuid(), claveTemporal: z.string() });
export const actualizarUsuarioBodySchema = z
    .object({ rol: rolAdminSchema.optional(), activo: z.boolean().optional() })
    .refine((b) => b.rol !== undefined || b.activo !== undefined, { message: 'nada que cambiar' });
export const configuracionSchema = z.object({
    vigenciaDias: z.number().int().min(1).max(90),
    /** periods the third party can consult back from the current one (RF-11); 3 by default */
    historialMeses: z.number().int().min(1).max(24),
});
export const errorRespuestaSchema = z.object({ mensaje: z.string(), codigo: z.string() });
//# sourceMappingURL=admin.js.map